/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import NoCommentPlaceholder from '../../components/NoCommentPlaceholder/NoCommentPlaceholder';
import CommentsList from '../CommentsList/CommentsList';
import ConnectedCommentInputContainer from '../CommentInputContainer/CommentInputContainer';
import LoadingAnimation from '../../components/LoadingAnimation/LoadingAnimation';
import NotMemberPlaceholder from '../../components/NotMemberPlaceholder/NotMemberPlaceholder';
import CommentInputLoader from '../../components/CommentInput/CommentInputLoader';
import {
  hasVisibleCommunity,
  generateVisibleCommunites
} from '../../utils/community/communityUtils';
import {
  fetchParentCommentsRequest,
  loadMoreParentCommentsRequest
} from '../../store/actions/comments/commentsActions';
import {
  fetchUserCommunitiesRequest,
  fetchUserRequest
} from '../../store/actions/user/userActions';
import {
  hideShowMoreMenu,
  toggleMentionModal,
  toggleShowCommunityMenu,
  toggleShowCommunitySelectModal
} from '../../store/actions/ui/uiActions';
import {
  setCommunityFilterType,
  setCommunityPostingId,
  setCommunityType
} from '../../store/actions/mentioning/mentioningActions';
import { setSettings } from '../../store/actions/settings/settingsActions';
import {
  isShowCommunityMenu,
  isShowCommunitySelectModal,
  isShowMentionsModal,
  isShowMoreVisible
} from '../../store/selectors/ui/uiSelectors';
import IconButton from '../../components/IconButton/IconButton';
import {
  getHasLoadMoreError,
  getIsLastPage,
  getIsLoadingMore
} from '../../store/selectors/comments/commentsSelectors';
import './styles/ApplicationContainer.css';
import {
  getOldestCommentDate,
  normaliseCommunities
} from '../../store/utils/utils';
import {
  COMMENTS_CONTEXT_SOCIAL_FEED,
  COMMENTS_DESIGN_STUDIO_SELECT_COMMUNITY
} from '../../utils/constants/commentConstants';
import { setCommunities } from '../../store/actions/community/communityActions';
import { fetchContentRequest } from '../../store/actions/content/contentActions';
import {
  getCommunityFilter,
  getCommunityIds,
  getSingleCommunityId,
  getUserVisibleCommunities,
  getAllCommunities,
  getCommunityPostingId
} from '../../store/selectors/community/communitySelectors';
import {
  getUserCommunitiesRequest,
  getCurrentUserCommunities
} from '../../store/selectors/user/userSelectors';
import { getContentRequest } from '../../store/selectors/content/contentSelectors';
import CommunityFilter from '../../components/CommunityFilter/CommunityFilter';
import MentionsLostModal from '../../components/MentionsLostModal/MentionsLostModal';
import { ALL_COMMUNITIES_CHOICE } from '../../utils/community/communityConstants';
import * as mentioningRegex from '../../utils/mentioning/mentioningRegex';
import { splitByValidMentions } from '../../utils/mentioning/mentionFormatters';
import { extractTextByCommunity } from '../../utils/mentioning/requestMentionableUsers';

const showNotMemberPlaceholder = (userCommunities, contentCommunities) => {
  const visibleCommunities = hasVisibleCommunity(
    contentCommunities,
    userCommunities
  );
  if (visibleCommunities === null || visibleCommunities === true) {
    return false;
  }
  return true;
};

export class ApplicationContainer extends Component {
  state = {
    proposedCommunitySwitch: null,
    updatedText: null
  };

  componentDidMount() {
    const {
      contentId,
      fetchUserRequest: fetchUser,
      fetchUserCommunitiesRequest: fetchUserCommunities,
      communityType,
      setCommunityType: setCommunity,
      commentsContext,
      setSettings: updateSettings,
      communities,
      setCommunities: updateCommunities,
      socialFeedShowInput,
      fetchContentRequest: fetchContent,
      fetchParentCommentsRequest: fetchParentComments,
      topicId
    } = this.props;

    window.addEventListener(
      COMMENTS_DESIGN_STUDIO_SELECT_COMMUNITY,
      function(e) {
        if (e.detail) {
          const {
            contentId: eventContentId,
            communityId: eventCommunityId
          } = e.detail;
          if (eventContentId === contentId) {
            updateSettings({
              socialFeedCommunityId: eventCommunityId
            });
          }
        }
      },
      false
    );
    updateSettings({ commentsContext, socialFeedShowInput });

    // We should only be getting communities data in this fasion when the comments client is either being loaded within another
    // app (Social Feed on design studio for example) where the parent app will provide the data or for testing purposes.
    // We must first normalise the data as the comments client project expects and deals with community data in a normalised way.
    if (Array.isArray(communities) && communities.length > 0) {
      updateCommunities(normaliseCommunities(communities));
    }
    setCommunity(communityType);
    // Avoids making unnecessary requests on the social feed
    if (commentsContext !== COMMENTS_CONTEXT_SOCIAL_FEED) {
      fetchContent(contentId, topicId);
    }

    // TODO: Replace this user
    // API call with data passsed
    // from the monolith
    // (for user avatar and language)
    fetchUser();
    fetchUserCommunities({ contentId });
    fetchParentComments({ contentId });
  }

  componentDidUpdate(prevProps) {
    const {
      communityFilter,
      isShowMoreVisible: showMoreVisible,
      isVisibleCommunityMenu,
      contentId,
      communityIds,
      fetchParentCommentsRequest: fetchParentComments,
      userCommunitiesRequest = {},
      currentContentRequest = {},
      currentUserCommunities: userCommunities,
      contentCommunities,
      communityPostingID,
      setCommunityPostingId: setCommunityToPostIn
    } = this.props;

    const { success: userCommunitiesSuccess } = userCommunitiesRequest;
    const { success: contentSuccess } = currentContentRequest;
    window.removeEventListener('click', this.hideShowMoreMenu);
    window.removeEventListener('click', this.hideFloatingMenu);

    if (showMoreVisible) {
      window.addEventListener('click', this.hideShowMoreMenu);
    }
    if (isVisibleCommunityMenu) {
      window.addEventListener('click', this.hideFloatingMenu);
    }

    if (
      communityFilter !== prevProps.communityFilter &&
      contentId &&
      communityIds
    ) {
      fetchParentComments({ contentId, communityIds });
    }
    // when we have multiple content communities but only one visible community then we can set the communityPostingID
    if (
      userCommunitiesSuccess &&
      contentSuccess &&
      Object.keys(contentCommunities).length > 1
    ) {
      const visibleCommunities = generateVisibleCommunites(
        contentCommunities,
        userCommunities
      );
      const visibleKeys = Object.keys(visibleCommunities);
      if (visibleKeys.length === 1 && !communityPostingID) {
        setCommunityToPostIn(visibleCommunities[visibleKeys[0]].id);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.hideShowMoreMenu);
    window.removeEventListener('click', this.hideFloatingMenu);
  }

  hideShowMoreMenu = (e) => {
    const { hideShowMoreMenu: hideShowMore } = this.props;
    e.stopPropagation();
    hideShowMore();
  };

  hideFloatingMenu = (e) => {
    const { toggleShowCommunityMenu: toggleCommunityMenu } = this.props;
    e.stopPropagation();
    toggleCommunityMenu();
  };

  handleCommunityFilterContextChange = (data) => {
    if (data) {
      this.setState({
        proposedCommunitySwitch: data
      });
    }
  };

  _handleLoadMoreComments = () => {
    const {
      loadMoreParentCommentsRequest: loadMoreCommentsRequest,
      contentId,
      comments,
      communityIds
    } = this.props;
    const loadMoreTimestamp = getOldestCommentDate(comments);
    loadMoreCommentsRequest(contentId, loadMoreTimestamp, communityIds);
  };

  _renderLoadMoreError = () => {
    const { hasLoadMoreError } = this.props;
    return (
      hasLoadMoreError && (
        <p styleName="load-more-error">{i18next.t('postingError')}</p>
      )
    );
  };

  _renderLoadMoreCommentsButton = () => {
    const { isLastPage, isLoadingMore, commentsContext } = this.props;
    return (
      !isLastPage &&
      !isLoadingMore &&
      commentsContext !== COMMENTS_CONTEXT_SOCIAL_FEED && (
        <div styleName="view-more-button-container">
          <IconButton
            testID="application_container_view_more_comments_button"
            label={i18next.t('viewMoreComments')}
            onClick={this._handleLoadMoreComments}
          />
          {this._renderLoadMoreError()}
        </div>
      )
    );
  };

  _renderLoadingAnimation = () => {
    const { isLoadingMore, hasLoadMoreError } = this.props;
    return isLoadingMore && !hasLoadMoreError && <LoadingAnimation />;
  };

  _renderCommunityContextSwitch = () => {
    const {
      isVisibleCommunityMenu,
      communityFilter,
      isFetchingComments,
      toggleShowCommunityMenu: toggleCommunityMenu,
      visibleCommunities: communities,
      commentsContext
    } = this.props;
    // don't display filter for 1 community or no community
    // don't display filter on feed
    // don't display filter if there are no common communitites
    // for user and selected content
    if (
      commentsContext === COMMENTS_CONTEXT_SOCIAL_FEED ||
      !communities ||
      Object.keys(communities).length <= 1
    ) {
      return null;
    }
    return (
      <CommunityFilter
        communityFilter={communityFilter}
        setCommunityFilter={this.handleCommunityFilterContextChange}
        isFetchingComments={isFetchingComments}
        isVisibleCommunityMenu={isVisibleCommunityMenu}
        toggleShowCommunityMenu={toggleCommunityMenu}
        communities={communities}
      />
    );
  };

  renderCommentContainer = () => {
    const {
      comments,
      isFetchingComments,
      fetchCommentsSuccess,
      commentsContext,
      userCommunitiesRequest = {},
      currentUserCommunities = null,
      communitiesComplete = false,
      currentContentRequest = {},
      contentComplete = false,
      contentCommunities = {},
      topicId
    } = this.props;
    const hasComments = comments && comments.length > 0;
    const { success: userCommunitiesSuccess } = userCommunitiesRequest;
    const { success: contentSuccess } = currentContentRequest;
    // When on the social feed and we have no comments dont show the loading animation or placeholder image
    if (commentsContext === COMMENTS_CONTEXT_SOCIAL_FEED && !hasComments)
      return null;

    if (isFetchingComments) return <LoadingAnimation />;

    if (!fetchCommentsSuccess) {
      return null;
    }

    if (hasComments)
      return (
        <>
          <CommentsList comments={comments} />
          {this._renderLoadMoreCommentsButton()}
          {this._renderLoadingAnimation()}
        </>
      );

    // communitiesComplete/contentComplete allows tests to trigger UI states without API calls
    const communitiesToTest =
      contentSuccess || contentComplete ? contentCommunities : {};

    if (topicId) {
      if (
        (userCommunitiesSuccess || communitiesComplete) &&
        (contentSuccess || contentComplete) &&
        showNotMemberPlaceholder(currentUserCommunities, communitiesToTest)
      ) {
        return <NotMemberPlaceholder message={i18next.t('notMember')} />;
      }
      if (!userCommunitiesSuccess) {
        return <LoadingAnimation />;
      }
      if (!contentSuccess) {
        return null;
      }
    }
    return <NoCommentPlaceholder />;
  };

  handleMentionLostOnCancel = async () => {
    const { communityFilter, toggleMentionModal: setMentionModal } = this.props;
    this.setState({
      proposedCommunitySwitch: communityFilter
    });
    setMentionModal(false);
  };

  handleCommunitySelected = () => {
    this.setState({
      proposedCommunitySwitch: null
    });
  };

  _updateCommunityFilter = async () => {
    const { proposedCommunitySwitch: communitySelectedData } = this.state;
    const {
      setCommunityFilterType: setCommunityFilter,
      setCommunityPostingId: setCommunityPosting,
      toggleMentionModal: setMentionModal
    } = this.props;
    setCommunityFilter(communitySelectedData);
    if (communitySelectedData.id === ALL_COMMUNITIES_CHOICE.id) {
      setCommunityPosting(undefined);
    } else {
      setCommunityPosting(communitySelectedData.id);
    }
    await this.handleMentionLost();
    setMentionModal(false);
  };

  checkCorrectMentions = async (communityPostId) => {
    const { updatedText } = this.state;

    const regexTemplate = mentioningRegex.mentionWithValidTemplate();
    const splitText = splitByValidMentions(regexTemplate)(updatedText);
    const text = await extractTextByCommunity(splitText, communityPostId);
    return text.join('');
  };

  handleMentionLost = async () => {
    const { proposedCommunitySwitch: communitySelectedData } = this.state;
    const updatedText = await this.checkCorrectMentions(
      communitySelectedData.id
    );
    this.setState({ updatedText });
  };

  renderInputContainer = () => {
    const {
      contentId,
      communityId,
      singleCommunityId,
      comments,
      visibleCommunities,
      toggleShowCommunitySelectModal: toggleShowCommunityModal,
      isVisibleCommunitySelectModal: isVisibleCommunityModal,
      toggleMentionModal: toggleMentionsModal,
      contentCommunities,
      currentContentRequest
    } = this.props;
    const {
      isFetching: isFetchingContent,
      error: errorContent
    } = currentContentRequest;
    const { updatedText } = this.state;
    const { proposedCommunitySwitch: communitySelectedData } = this.state;
    if (isFetchingContent) {
      return <CommentInputLoader />;
    }
    if (errorContent) {
      return <p styleName="content-load-error">{i18next.t('postingError')}</p>;
    }
    return (
      <ConnectedCommentInputContainer
        contentId={contentId}
        communityId={communityId || singleCommunityId}
        // Always want this input to be the top most level to
        // avoid colliding with any of the components below it.
        zIndex={comments.length + 1}
        toggleShowCommunitySelectModal={toggleShowCommunityModal}
        isVisibleCommunitySelectModal={isVisibleCommunityModal}
        communities={visibleCommunities}
        contentCommunities={contentCommunities}
        isMultipleCommunityPosting={
          contentCommunities && Object.keys(contentCommunities).length > 1
        }
        toggleMentionModal={toggleMentionsModal}
        communitySelectedData={communitySelectedData}
        handleCommunitySelected={this.handleCommunitySelected}
        inputValue={updatedText}
        setInputValue={(val) => this.setState({ updatedText: val })}
      />
    );
  };

  render() {
    const {
      isShowMentionsModal: isVisibleMentionsModal,
      commentsContext
    } = this.props;
    return (
      <div styleName="container">
        {this._renderCommunityContextSwitch()}
        {this.renderInputContainer()}
        {this.renderCommentContainer()}
        {isVisibleMentionsModal &&
          commentsContext !== COMMENTS_CONTEXT_SOCIAL_FEED && (
            <MentionsLostModal
              onConfirm={this._updateCommunityFilter}
              onClose={this.handleMentionLostOnCancel}
            />
          )}
      </div>
    );
  }
}

ApplicationContainer.propTypes = {
  comments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  contentId: PropTypes.number.isRequired,
  isFetchingComments: PropTypes.bool.isRequired,
  communityId: PropTypes.number,
  fetchParentCommentsRequest: PropTypes.func.isRequired,
  fetchUserRequest: PropTypes.func.isRequired,
  fetchUserCommunitiesRequest: PropTypes.func.isRequired,
  isShowMoreVisible: PropTypes.bool,
  hideShowMoreMenu: PropTypes.func.isRequired,
  communityType: PropTypes.string,
  setCommunityType: PropTypes.func.isRequired,
  loadMoreParentCommentsRequest: PropTypes.func.isRequired,
  isLastPage: PropTypes.bool,
  isLoadingMore: PropTypes.bool,
  hasLoadMoreError: PropTypes.bool,
  commentsContext: PropTypes.string,
  setSettings: PropTypes.func.isRequired,
  communities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ),
  visibleCommunities: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ),
  setCommunities: PropTypes.func.isRequired,
  socialFeedShowInput: PropTypes.bool,
  fetchContentRequest: PropTypes.func.isRequired,
  toggleShowCommunityMenu: PropTypes.func.isRequired,
  toggleShowCommunitySelectModal: PropTypes.func.isRequired,
  isVisibleCommunityMenu: PropTypes.bool,
  isVisibleCommunitySelectModal: PropTypes.bool,
  communityFilter: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  communityIds: PropTypes.arrayOf(PropTypes.number),
  toggleMentionModal: PropTypes.func.isRequired,
  isShowMentionsModal: PropTypes.bool,
  setCommunityFilterType: PropTypes.func.isRequired,
  setCommunityPostingId: PropTypes.func.isRequired,
  singleCommunityId: PropTypes.number,
  topicId: PropTypes.number,
  communitiesComplete: PropTypes.bool,
  contentComplete: PropTypes.bool,
  userCommunitiesRequest: PropTypes.shape({
    success: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    isFetching: PropTypes.bool
  }),
  currentContentRequest: PropTypes.shape({
    success: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    isFetching: PropTypes.bool
  })
};

ApplicationContainer.defaultProps = {
  isShowMoreVisible: false,
  communityId: null,
  communityType: null,
  isLastPage: true,
  isLoadingMore: false,
  hasLoadMoreError: false,
  commentsContext: null,
  communities: [],
  socialFeedShowInput: null,
  isVisibleCommunityMenu: false,
  isVisibleCommunitySelectModal: false,
  communityIds: null,
  visibleCommunities: {},
  isShowMentionsModal: false,
  singleCommunityId: null,
  topicId: null,
  userCommunitiesRequest: {},
  currentContentRequest: {},
  communitiesComplete: false,
  contentComplete: false
};

const mapStateToProps = (state) => {
  return {
    isFetchingComments: state.commenting.isFetching,
    fetchCommentsSuccess: state.commenting.success,
    comments: state.commenting.comments,
    isShowMoreVisible: isShowMoreVisible(state),
    isVisibleCommunityMenu: isShowCommunityMenu(state),
    isVisibleCommunitySelectModal: isShowCommunitySelectModal(state),
    isLastPage: getIsLastPage(state),
    isLoadingMore: getIsLoadingMore(state),
    hasLoadMoreError: getHasLoadMoreError(state),
    communityFilter: getCommunityFilter(state),
    communityIds: getCommunityIds(state),
    visibleCommunities: getUserVisibleCommunities(state),
    isShowMentionsModal: isShowMentionsModal(state),
    // This id is only used when comments are viewed on content with one community that are used in a topic
    // This is because in all other scenarios we either receive a communityId when comment client is initialised or the user
    // has to select a community in cases where multiple communities are available.
    singleCommunityId: getSingleCommunityId(state),
    userCommunitiesRequest: getUserCommunitiesRequest(state),
    currentUserCommunities: getCurrentUserCommunities(state),
    currentContentRequest: getContentRequest(state),
    contentCommunities: getAllCommunities(state),
    communityPostingID: getCommunityPostingId(state)
  };
};

const mapDispatchToProps = {
  fetchParentCommentsRequest,
  fetchUserRequest,
  hideShowMoreMenu,
  setCommunityType,
  loadMoreParentCommentsRequest,
  setSettings,
  setCommunities,
  fetchContentRequest,
  toggleShowCommunityMenu,
  toggleShowCommunitySelectModal,
  setCommunityFilterType,
  fetchUserCommunitiesRequest,
  setCommunityPostingId,
  toggleMentionModal
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationContainer);
